import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=0f0b38fb&scoped=true&"
import script from "./AddCollection.vue?vue&type=script&lang=js&"
export * from "./AddCollection.vue?vue&type=script&lang=js&"
import style0 from "./AddCollection.vue?vue&type=style&index=0&id=0f0b38fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b38fb",
  null
  
)

export default component.exports